<template>
  <div class="custom-switch" style="display: none">
    <label class="switch">
      <!--      <input ref="MyCheckbox" type="checkbox" v-model="value" @input="changed" />-->
      <input type="checkbox" :checked="value" @change="changed($event)" />
      <span
        class="round slider"
        :class="{ sliderR: sliderR, sliderL: sliderL }"
      ></span>
    </label>
  </div>
</template>

<script>
import {
  onMounted,
  onUnmounted,
  ref,
  triggerRef,
  watch,
} from "@vue/runtime-core";
import store from "@/store";
import { onRenderTracked } from "vue";
export default {
  name: "CustomSwitch",
  // props: {
  //   'modelValue': {
  //     type: Boolean,
  //     required: true
  //   },
  // },
  emits: ["update:checked"],
  setup(props, { emit }) {
    let value = ref(null);
    let sliderL = ref(null);
    let sliderR = ref(null);
    const MyCheckbox = ref(null);

    onMounted(() => {
      console.log("onMounted");
    });

    const set = (v) => {
      value.value = v;
      sliderL.value = v;
      sliderR.value = !v;
    };

    const changed = (ev) => {
      sliderL.value = ev.target.checked;
      sliderR.value = !ev.target.checked;

      emit("update:checked", ev.target.checked);

      // if (store.state.preferences) {
      //   let theme = store.state.preferences.theme
      //   console.log('changed to ' + theme)
      //
      //   // sliderL.value = theme === 'DARK'
      //   // sliderR.value = theme === 'LIGHT'
      //
      //   // emit("update:modelValue", props.modelValue)
      // }
    };
    return {
      MyCheckbox,
      sliderL,
      sliderR,
      value,
      set,
      changed,
    };
  },
};
</script>

<style scoped>
</style>
